/*eslint-disable*/export const messages=JSON.parse("{\"button.aria.loading\":[\"Laddar ...\"]}");